import React, { createContext, useContext } from 'react';

const ALL_ICON_KEYS = ['rings', 'flower', 'mailHeart', 'candle', 'calendar'];

const config = {
  library: 'mdi',
  enabledIcons: new Set(ALL_ICON_KEYS),
  animation: 'none',
  opacity: 0.12,
};

const IconConfigContext = createContext({ config });

export function IconConfigProvider({ children }) {
  return (
    <IconConfigContext.Provider value={{ config }}>
      {children}
    </IconConfigContext.Provider>
  );
}

export function useIconConfig() {
  return useContext(IconConfigContext);
}
